module.exports = __webpack_public_path__ + "img/club_house.852e67e1.webp";